/**
 * Language Selector — persists locale and updates document direction
 */
import { Dropdown } from 'bootstrap';

const STORAGE_KEY = 'nw-language';

export const LanguageManager = {
  init() {
    const dropdown = document.querySelector('.nw-language-dropdown');
    if (!dropdown) return;

    this.dropdown = dropdown;
    this.toggle = dropdown.querySelector('[data-bs-toggle="dropdown"]');
    this.currentFlag = dropdown.querySelector('[data-nw-language-current-flag]');
    this.currentCode = dropdown.querySelector('[data-nw-language-current-code]');
    this.items = dropdown.querySelectorAll('[data-nw-language]');

    this.apply(this.getPreferred(), false);
    this.bindItems();
  },

  getPreferred() {
    return localStorage.getItem(STORAGE_KEY) || 'en';
  },

  set(code) {
    localStorage.setItem(STORAGE_KEY, code);
    this.apply(code);
    document.dispatchEvent(new CustomEvent('nw:language-change', { detail: { language: code } }));
  },

  apply(code, updateStorage = true) {
    const item = this.dropdown?.querySelector(`[data-nw-language="${code}"]`);
    if (!item) return;

    const { nwLanguageCode: shortCode, nwLanguageFlag: flagCode } = item.dataset;

    this.items.forEach((el) => {
      const isActive = el.dataset.nwLanguage === code;
      el.classList.toggle('active', isActive);
      el.setAttribute('aria-selected', String(isActive));
    });

    if (this.currentFlag) {
      this.currentFlag.src = `https://flagcdn.com/${flagCode}.svg`;
    }

    if (this.currentCode) {
      this.currentCode.textContent = shortCode;
    }

    document.documentElement.lang = code;
    document.documentElement.dir = item.hasAttribute('data-nw-language-rtl') ? 'rtl' : 'ltr';

    if (updateStorage) {
      localStorage.setItem(STORAGE_KEY, code);
    }
  },

  bindItems() {
    this.items.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.set(btn.dataset.nwLanguage);
        Dropdown.getInstance(this.toggle)?.hide();
      });
    });
  },
};
